import { render } from "./Home.vue?vue&type=template&id=dcaa6d4e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=dcaa6d4e&lang=css"

import exportComponent from "C:\\Surilova\\FrontEnd\\Bookshelf-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__